<template>
  <b-dropdown
    id="dropdown-1"
    class="m-md-2"
    variant="primary"
  >
    <template #button-content>
      <FontAwesomeIcon
        class="margin"
        icon="fw fa-plus"
        size="xl"
      />
      Aggiungi
    </template>
    <b-dropdown-group
      id="dropdown-group-1"
      header="Aggiungi"
    >
      <b-dropdown-item
        v-b-modal.modal-login
        v-ripple.400="'rgba(113, 102, 240, 0.15)'"
        @click="openUploadModal()"
      >
        <FontAwesomeIcon
          class="margin"
          icon="file-upload"
          size="lg"
        />
        File
      </b-dropdown-item>
      <b-dropdown-item @click="openFolderModal()">
        <FontAwesomeIcon
          class="margin"
          icon="folder"
          size="lg"
        />
        Cartella
      </b-dropdown-item>
      <b-dropdown-item @click="openTreeModal()">
        <FontAwesomeIcon
          class="margin"
          icon="folder-tree"
          size="lg"
        />
        Alberatura
      </b-dropdown-item>
      <!--      <b-dropdown-item @click="openAddUserModal()">-->
      <!--        <FontAwesomeIcon-->
      <!--          class="margin"-->
      <!--          icon="user-plus"-->
      <!--          size="lg"-->
      <!--        />-->
      <!--        Utente-->
      <!--      </b-dropdown-item>-->
      <!--      <b-dropdown-item @click="ingestFTP()">-->
      <!--        <FontAwesomeIcon-->
      <!--          class="margin"-->
      <!--          icon="folder-closed"-->
      <!--          size="lg"-->
      <!--        />-->
      <!--        Da FTP-->
      <!--      </b-dropdown-item>-->
    </b-dropdown-group>
    <b-dropdown-divider />
    <b-dropdown-item @click="openStagingModal()">
      <FontAwesomeIcon
        class="margin"
        icon="arrow-up-from-bracket"
        size="lg"
      />
      Staging
    </b-dropdown-item>
    <b-dropdown-item @click="openTrashedModal()">
      <FontAwesomeIcon
        class="margin"
        icon="trash-can"
        size="lg"
      />
      Cestino
    </b-dropdown-item>
    <b-dropdown-item @click="openDownloadsModal()">
      <FontAwesomeIcon
        class="margin"
        icon="file-zipper"
        size="lg"
      />
      I miei download
    </b-dropdown-item>
    <!-- <b-dropdown-item>Second Action</b-dropdown-item>
    <b-dropdown-item>Third Action</b-dropdown-item>
    <b-dropdown-divider />
    <b-dropdown-item active> Active action </b-dropdown-item>
    <b-dropdown-item disabled> Disabled action </b-dropdown-item> -->
  </b-dropdown>
</template>

<script>
import {
  BDropdown, BDropdownItem, BDropdownDivider, BDropdownGroup,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import useMyStore from '@/services/useMyStore'
import { RepositoryFactory } from '@/api/RepositoryFactory'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

const ftpRepository = RepositoryFactory.get('ftp')

export default {
  name: 'FilesAddButton',
  directives: { Ripple },
  components: {
    BDropdown,
    BDropdownItem,
    BDropdownDivider,
    BDropdownGroup,
  },
  setup() {
    const { uploadMethod } = useMyStore()
    return { uploadMethod }
  },
  methods: {
    openTreeModal() {
      this.$bvModal.show('treefolder-modal')
    },
    openFolderModal() {
      this.$bvModal.show('folder-modal')
    },
    openUploadModal() {
      this.uploadMethod = 'new'
      this.$bvModal.show('upload-modal')
    },
    async ingestFTP() {
      const { data } = await ftpRepository.ingest()

      if (data.code) {
        if (data.data.files.length > 0) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: `Successo! ${data.data.files.length} file(s) aggiunti`,
              icon: 'CheckIcon',
              variant: 'success',
            },
          },
          {
            position: 'top-center',
          })
        } else {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Nessun File trovato!',
              icon: 'InfoIcon',
              variant: 'info',
            },
          },
          {
            position: 'top-center',
          })
        }
      } else {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Qualcosa è andato storto!',
            icon: 'CheckIcon',
            variant: 'error',
          },
        },
        {
          position: 'top-center',
        })
      }
      this.$emit('loading', false)
    },
    openStagingModal() {
      this.$bvModal.show('staging-modal')
    },
    openTrashedModal() {
      this.$bvModal.show('trash-modal')
    },
    openDownloadsModal() {
      this.$bvModal.show('downloads-modal')
    },
    openAddUserModal() {
      this.$bvModal.show('userAdd-modal')
    },
  },

}
</script>

<style scoped>
.margin {
  margin-right: 0.5rem;
}
</style>
